<template>
  <el-card class="record-card" shadow="hover">
    <!--标题 -->
    <div slot="header" class="boxHeader">
      <!-- 关联任务 -->

      <!-- </el-col> -->
      <div style="padding-top: 5px;display:flex">
        <el-checkbox
          v-show="isCheckbox"
          v-model="record.checked"
          style="margin-left: 5px;"
          @change="checkboxChange"
        ></el-checkbox>
        <el-tooltip :content="record.MyFocus ? '取消关注' : '设为关注'" placement="bottom" effect="light">
          <!-- <span @click="updateMyFocus"
              title="关注"
            >
          <i class="icon iconfont el-icon-star-off"
          style="font-size: 18px"></i></span>-->
          <span @click="updateMyFocus" class="recordNameIcon">
            <i
              :class="record.MyFocus ? 'el-icon-star-on' : 'el-icon-star-off'"
              :style="record.MyFocus ? 'font-size: 30px' : 'font-size: 26px'"
            ></i>
          </span>
        </el-tooltip>
        <el-tooltip :content="record.NAME" placement="bottom-start" effect="light">
          <a @click="showRecordDetail(record.ID)" class="recordName" :style="nameStyle">
            <div class="words" v-html="highlight('工作记录名称', record.NAME)"></div>
          </a>
        </el-tooltip>
        <div class="tag" :style="tagStyle" v-html="tagNames"></div>
        <div class="recordType">
          <el-tag style="vertical-align: top;" effect="plain" v-if="isTodoList">
            <el-checkbox
              size="small"
              style="color: #409eff;"
              v-model="recordCompleted"
              @change="changeState"
            >代办事项</el-checkbox>
          </el-tag>
          <el-tag style="vertical-align: top;" effect="plain" v-else>
            {{
            recordTypeName
            }}
          </el-tag>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div>
      <div style="margin-bottom: 5px;
    min-height: 50px;">
        <span
          class="recordMain"
          style="word-wrap: break-word;font-size: 14px;"
          v-html="visibleContent"
        ></span>
        <!-- 关联工作记录 -->
        <RecordRelation
          v-if="allContentShow && recordRelations.length > 0"
          :recordArray="recordArray"
          @removeRecordRelation="removeRecordRelation"
          :recordId="record.ID"
          :enabled="isMyCreated(record.CREATEUSERID)"
        ></RecordRelation>
        <el-button
          type="text"
          style="display:inline-block"
          size="mini"
          v-show="!allContentShow && bigContentShow"
          @click="showContent(true)"
        >
          阅读全文
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
      </div>
      <!-- 创建信息 -->
      <div class="bottom-div">
        <div class="column-div">
          <!-- 创建人 -->
          <div class="columnItem-div">
            <span class="columnName">创建人</span>
            <span class="columnValue" v-html="highlight('工作记录创建人', record.CREATEUSERNAME)"></span>
          </div>
          <!-- 编号 -->
          <div class="columnItem-div">
            <span class="columnName">编号</span>
            <span class="columnValue">{{ record.INSTANCE }}</span>
          </div>
          <!-- 记录类型 -->
          <!-- <div class="columnItem-div">
            <span class="columnName">记录类型</span>
            <span class="columnValue">{{recordTypeName}}</span>
          </div>-->
          <!-- 重要级别 -->
          <div class="columnItem-div">
            <span class="columnName">重要级别</span>
            <el-rate
              :max="3"
              class="columnValue"
              style="display: inline-block;"
              :icon-classes="iconClasses"
              disabled-void-icon-class="icon iconfont icon-dengji1"
              void-icon-class="icon iconfont icon-dengji1"
              @change="changeRate"
              title="重要等级"
              :disabled="!isMyCreated(record.CREATEUSERID)"
              v-model="record.DEGREE"
            ></el-rate>
          </div>
          <!-- 创建时间 -->
          <div class="columnItem-div">
            <span class="columnName">创建时间</span>
            <span class="columnValue">
              {{
              record.CREATETIME | timeFormater
              }}
            </span>
          </div>
          <!-- 接收人 -->
          <div class="columnItem-div" v-show="record.Members != null && record.Members.length > 0">
            <span class="columnName">接收人</span>
            <span class="columnValue">{{ recordExcuteUserNames }}</span>
          </div>
          <!-- 截止时间 -->
          <div class="columnItem-div" v-show="record.ENDTIME">
            <span class="columnName">截止时间</span>
            <span class="columnValue">{{ record.ENDTIME | timeFormater }}</span>
          </div>
        </div>
        <div class="column-right">
          <el-button
            type="text"
            v-show="allContentShow && bigContentShow"
            @click="showContent(false)"
          >
            收起
            <i class="el-icon-arrow-up el-icon--right"></i>
          </el-button>
        </div>
      </div>
      <RecordTaskRelationTagList
        :relations="otherRelations"
        :closable="isMyCreated(record.CREATEUSERID)"
        @delRelation="delRelation"
      ></RecordTaskRelationTagList>

      <el-row class="filePanel" v-show="record.Files.length > 0">
        <fileListView :fileList="fileList" @delFiles="delFiles"></fileListView>
      </el-row>
      <RecordButton :record="record" @addRecordRelation="addRecordRelation" @successed="successed"></RecordButton>
      <comment :MainId="recordId" :TopNum="'2'" :Type="'1'" :DefaultShowInput="false"></comment>
    </div>
  </el-card>
</template>

<script>
import fileListView from "../../../components/common/fileListView.vue";
import RecordButton from "./RecordButton.vue";
import {
  AddRecordRelation,
  DelRecordRelation,
  SaveTaskTags,
  AddVote,
  DelRecord,
  DelAttachFile,
  UpdateRecordDegree,
  AddFocusRecord,
  DelFocusRecord,
  GetRecordRelationByRecordId,
  ChangeRecordState,
  GetRecordListByIds,
  GetRecordById,
} from "@/api/modules/basicData/task";
import comment from "@/components/common/comment.vue";
import RecordRelation from "./RecordRelation";
import RecordTaskRelationTagList from "./RecordTaskRelationTagList";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
var person = {
  ID: cookieUser.userId,
  NAME: cookieUser.realName,
  DEPTID: cookieUser.departmentId,
  DEPTNAME: cookieUser.departmentName,
  COMPANYID: cookieUser.organizationId,
  COMPANYNAME: cookieUser.organizationName,
};
export default {
  name: "TaskRecordCard",
  components: {
    RecordButton,
    RecordRelation,
    fileListView,
    comment,
    // comment: () => import("@/components/common/comment.vue"),
    RecordTaskRelationTagList,
  },
  props: {
    record: {
      type: Object,
      default: {},
    },
    isCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      btnName: "",
      recordId: "",
      btnIcon: ["el-icon-arrow-down", "el-icon--right"],
      iconClasses: [
        "icon iconfont icon-dengji",
        "icon iconfont icon-dengji",
        "icon iconfont icon-dengji",
      ],
      allContentShow: false,
      luceneContentShow: false,
      bigContentShow: false,
      visibleContent: "",
      fileList: [],
      recordCompleted: false,
      recordArray: [],
    };
  },
  filters: {
    degreeFormater: function (value) {
      return value + 1;
    },
  },
  computed: {
    recordRelations() {
      return this.record.Relations != null
        ? this.record.Relations.filter((o) => o.RELATIONTYPE == 2)
        : [];
    },
    otherRelations() {
      return this.record.Relations != null
        ? this.record.Relations.filter((o) => o.RELATIONTYPE != 2)
        : [];
    },
    nameStyle() {
      return this.record.Tags != undefined && this.record.Tags != null
        ? `max-width:calc(100% - ${this.record.Tags.length * 70 + 140}px)`
        : "";
    },
    tagStyle() {
      return this.record.Tags != undefined && this.record.Tags != null
        ? `width:${this.record.Tags.length * 70}px`
        : "";
    },
    tagNames() {
      if (this.record.Tags != null && this.record.Tags.length > 0) {
        return this.record.Tags.map(
          (tag) =>
            ` <span style="background:${tag.COLOR}" class="taskListTag-span">${tag.TAGNAME}</span>`
        ).join(" ");
      }
      return "";
    },
    recordExcuteUserNames() {
      return this.record.Members == null
        ? ""
        : this.record.Members.map((o) => o.USERNAME).join(",");
    },
    isTodoList: function () {
      if (this.record.RECORDTYPE == 2) {
        if (
          this.record.Members != null &&
          this.record.Members.some((o) => o.USERID == cookieUser.userId)
        )
          return true;
        else if (this.record.CREATEUSERID == cookieUser.userId) return true;
      }
      return false;
    },
    recordTypeName() {
      switch (this.record.RECORDTYPE) {
        case 1:
          return "问询";
        case 2:
          return "代办事项";
        case 3:
          return "催办";
        case 4:
          return "提醒";
        case 5:
          return "会议记录";
        case 0:
        default:
          return "工作日志";
      }
    },
  },
  mounted() {
    this._loadRecord();
  },
  watch: {
    record(newValue) {
      if (newValue) {
        this.record = newValue;
        this.recordId = newValue.ID;
        this.allContentShow = false;
        this._loadRecord();
      }
    },
  },
  methods: {
    changeState(val) {
      //如果保存失败了，会将check状态还原回去，
      //会调用change方法，这时候需要return
      if (this.record.STATE == (val ? 2 : 0)) return;
      ChangeRecordState(val ? 2 : 0, this.record.ID, person).then((result) => {
        if (result.ResultCode > 0) {
          this.record.STATE = val ? 2 : 0;
          this.$emit("successed");
          this.$message.success("变更状态成功");
        } else {
          this.recordCompleted = !val;
          this.$message.error(result.MsgInfo);
        }
      });
    },

    changeRate(val) {
      console.log("changeRate", val);
      if (this.rate == val && val != 0) {
        UpdateRecordDegree(this.record.ID, 0).then((result) => {
          if (result.ResultCode < 0) {
            this.$message.error(result.MsgInfo);
          } else {
            this.rate = 0;
            this.record.DEGREE = 0;
          }
        });
      } else {
        UpdateRecordDegree(this.record.ID, val).then((result) => {
          if (result.ResultCode < 0) {
            this.$message.error(result.MsgInfo);
          } else {
            this.rate = val;
          }
        });
      }
    },
    successed() {
      this.$emit("successed");
    },

    addRecordRelation(item) {
      var relation = [
        {
          RELATIONID: item.ID,
          RECORDID: this.record.ID,
          RELATIONTYPE: 2,
          RELATIONINSTANCE: item.INSTANCE,
          RELATIONNAME: item.NAME,
          SORTINDEX: this.recordArray.length,
        },
      ];
      AddRecordRelation(relation).then((result) => {
        if (result.ResultCode > 0) {
          this.record.Relations = this.record.Relations.concat(relation);
          GetRecordById(item.ID).then((data) => {
            this.recordArray.push(data);
            this.showContent(true);
          });
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },
    removeRecordRelation(val) {
      if (this.recordArray.length > 0) {
        this.recordArray.splice(this.recordArray.indexOf(val), 1);
        var index = this.record.Relations.findIndex(
          (o) => o.RELATIONID == val.ID
        );
        if (index > -1) this.record.Relations.splice(index, 1);
        this.showContent(true);
      }
    },
    _getRecordArray() {
      if (this.recordRelations.length > 0) {
        var ids = this.recordRelations.map((o) => o.RELATIONID).join(",");
        GetRecordListByIds(ids, cookieUser.userId).then((result) => {
          if (result) {
            result.forEach((r) => {
              let relation = this.recordRelations.find(
                (o) => o.RELATIONID == r.ID
              );
              r.SORTINDEX = relation ? relation.SORTINDEX : 0;
            });
            this.recordArray = result.sort((a, b) => {
              return a.SORTINDEX - b.SORTINDEX;
            });
          }
        });
      }
    },
    delFiles(id) {
      DelAttachFile(id).then((res) => {
        console.log(res);
      });
    },
    checkboxChange(newVal) {
      let isAddOrDelete = newVal ? true : false;
      this.$emit("select", this.record, isAddOrDelete);
    },
    getCardChecked(row, checked) {
      this.record.checked = checked;
      this.dataSource.forEach((v) => {
        if (row.ID === v.ID) v.checked = checked;
      });
    },
    _loadRecord() {
      if (this.record) {
        //是否显示完成总结按钮
        this.fileList = [];
        if (this.record.Files)
          this.record.Files.forEach((item) => {
            let c = Object.assign({}, item);
            c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
            this.fileList.push(c);
          });
        console.log("fileList", this.fileList);
        this.recordCompleted = this.record.STATE == 2;
        this.luceneContentShow = false;
        if (this.record.INFO) {
          this.bigContentShow = this.record.INFO.length > 100;
          if (this.bigContentShow == false) {
            //如果内容不多，看看是否有关联的工作记录
            this.bigContentShow = this.record.Relations.some(
              (o) => o.RELATIONTYPE == 2
            );
          }
        } else {
          this.bigContentShow = this.record.Relations.some(
            (o) => o.RELATIONTYPE == 2
          );
        }
        if (this.bigContentShow) {
          this.visibleContent =
            "<p>" +
            this.ellipsis(this.delHtmlTag(this.record.INFO), 100) +
            "...</p>";
        } else {
          let info = this.record.INFO;
          if (this.record.CompleteInfo) {
            if (this.record.CompleteInfo.MEMO)
              info =
                info +
                `<br/><h4>完成总结:</h4><br/>` +
                this.record.CompleteInfo.MEMO;
          }
          this.visibleContent = info;
          this.$previewRefresh();
        }
        this._highlightContent(this.record);
      }
    },

    _highlightContent(val) {
      if (val.MatchFields) {
        let fieldRow = this.record.MatchFields.filter(
          (p) => p.Name === "工作记录内容"
        );
        if (fieldRow != null && fieldRow.length > 0) {
          this.visibleContent = fieldRow[0].Value;
          //全文检索如果文字本身超过100，则显示阅读全文，没有超过100，默认全文检索展示所有文字
          this.luceneContentShow = true;
        }
      }
    },
    highlight(title, fieldValue) {
      //高亮显示
      let highlightStr = "";
      console.log(this.record.MatchFields);
      if (this.record.MatchFields) {
        let fieldRow = this.record.MatchFields.filter((p) => p.Name === title);
        if (fieldRow != null && fieldRow.length > 0) {
          highlightStr = fieldRow[0].Value;
        } else highlightStr = fieldValue;
      } else {
        highlightStr = fieldValue;
      }
      highlightStr = highlightStr
        .replace(/<script>/, "&lt;script&gt;")
        .replace(/<\/script>/, "&lt;/script&gt;");
      console.log(highlightStr);
      return highlightStr;
    },
    updateMyFocus() {
      console.log("focus", this.record.MyFocus);
      if (this.record.MyFocus) {
        DelFocusRecord(this.record.ID, person).then((result) => {
          if (result.ResultCode > 0) {
            this.record.MyFocus = false;
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      } else {
        AddFocusRecord({
          RECORDID: this.record.ID,
          USERID: cookieUser.userId,
          DEPTID: cookieUser.departmentId,
          COMPANYID: cookieUser.organizationId,
        }).then((result) => {
          if (result.ResultCode > 0) {
            this.record.MyFocus = true;
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      }
      console.log("MyFocus", this.record.MyFocus);
    },
    delRelation(val) {
      this.record.Relations.splice(this.record.Relations.indexOf(val), 1);
    },
    isMyCreated(userId) {
      console.log(userId + "----" + cookieUser.userId);
      if (userId) return userId === cookieUser.userId;

      return false;
    },
    showContent(visible) {
      this.allContentShow = visible;
      if (this.record.INFO) {
        this.bigContentShow = this.record.INFO.length > 100;
        if (this.bigContentShow == false) {
          //如果内容不多，看看是否有关联的工作记录
          this.bigContentShow = this.record.Relations.some(
            (o) => o.RELATIONTYPE == 2
          );
        }
      } else {
        this.bigContentShow = this.record.Relations.some(
          (o) => o.RELATIONTYPE == 2
        );
      }
      if (!this.allContentShow) {
        if (this.luceneContentShow) {
          this._highlightContent(this.record);
        } else {
          this.visibleContent =
            "<p>" +
            this.ellipsis(this.delHtmlTag(this.record.INFO), 100) +
            "...</p>";
        }
      } else {
        let info = this.record.INFO;
        if (this.record.CompleteInfo) {
          if (this.record.CompleteInfo.MEMO)
            info =
              info +
              `<br/><h3>完成总结</h3><br/>` +
              this.record.CompleteInfo.MEMO;
        }

        this.visibleContent = info;
        if (this.recordArray.length == 0 && this.recordRelations.length > 0)
          this._getRecordArray();
        this.$previewRefresh();
      }
    },
    showRecordDetail(recordid) {
      let routeUrl = `${location.href.substr(
        0,
        location.href.lastIndexOf("/")
      )}/recordinfo?recordid=${recordid}`;
      console.log(routeUrl);
      window.open(routeUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.recordMain /deep/ a {
  color: #70c063;
}

.recordMain /deep/ a:hover {
  color: #fc8800;
}

.record-card /deep/ .el-card__header {
  padding: 5px 2px;
  background: #f4f7f9;
}

.record-card /deep/ .el-card__body {
  padding: 10px 18px !important;
}

.record-card /deep/ .el-rate__item {
  padding-top: 2px;
}
</style>
<style lang="scss" scoped>
.bottom-div {
  display: flex;
  align-items: bottom;
  justify-content: space-between;
  border-top: 2px dashed #e3e3e3;
  padding-top: 5px;
  .columnItem-div {
    display: flex;
    margin: 0 10px 5px 0;
  }
}

.column-div {
  margin-right: 5px;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  display: flex;
}

// .bottom-div > * {
//   margin-right: 10px;
// }

.relation-div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  //margin-bottom: 5px;
}

.relation-div > * {
  margin-right: 10px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.6;
}

.boxHeader {
  height: 40px;
  line-height: 2em;
}

.content-span {
  width: 100%;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: normal !important;
  display: flex;
  line-height: 1.6;
  align-items: center;
}

.relation-tag {
  margin-top: 5px;
  height: 26px !important;
  line-height: 20px !important;
  padding: 0 4px !important;
  cursor: pointer;
}

.columnName {
  color: #999999;
  margin-right: 2px;
  font-size: 12px;
}

.columnValue {
  font-size: 12px;
  margin-right: 10px;
}

.recordNameIcon {
  color: rgb(247, 186, 42);
  cursor: pointer;

  // display: table-cell;
  padding-right: 5px;
  padding-left: 10px;
}

.add {
  color: coral;
  cursor: pointer;
  margin-right: 2px;
  //display: table-cell;
}

.del {
  color: #409eff;
  cursor: pointer;
  margin-right: 2px;
  //display: table-cell;
}

.recordName {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.recordType {
  margin-left: auto;
  text-align: right;
  margin-right: 5px;
}

.words {
  text-decoration: none;
  // width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-wrap: normal;
}

.tag {
  position: sticky;
  display: block;
  right: 0;
  margin-left: 5px;
}
</style>
